<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'FormsSubmissionsProvision',
  created() {
    this.fetchForms()
    this.fetchSavedFilters().then(() => {
      this.checkForActiveSavedFilter()
      this.fetchSavedFilterCounts()
    })
    this.fetchJobData()
  },
  methods: {
    ...mapActions({
      fetchForms: 'forms/fetch',
      fetchSavedFilters: 'formSubmissionsFilters/fetchAllSavedFilters',
      fetchSavedFilterCounts:
        'formSubmissionsFilters/fetchAllSavedFilterCountsAsync',
      checkForActiveSavedFilter:
        'formSubmissionsFilters/checkForMatchingSavedFilter',
      fetchJobData: 'fetchJobData',
    }),
  },
}
</script>
